module.exports = __webpack_public_path__ + "img/footer_logo.ac78ffe8.svg";